import {BooleanInput, DateInput, SimpleForm,} from "react-admin";
import {FormProps} from "../../shared/types";
import {initInput} from "../../shared/utils";
import {Grid} from "@material-ui/core";
import {CustomToolbar} from "../../components/CustomToolbar";
import {ReferenceInputInvoice} from "../../components/reference-inputs/ReferenceInputInvoice";

export const BankReceiptEditForm = (props: FormProps) => {

  return (
    <SimpleForm
      {...props}
      toolbar={
        <CustomToolbar canEdit={props.canEdit} canDelete={props.canDelete} />
      }
    >
      <Grid spacing={2} container alignItems="center" style={{ width: "100%" }}>
        <Grid item xs={6}>
            <BooleanInput
                {...initInput(
                    "loaded",
                    props.fieldOptions,
                    props.canEdit
                )}
            />
        </Grid>
        <Grid item xs={6}>
            <BooleanInput
                {...initInput(
                    "generated",
                    props.fieldOptions,
                    props.canEdit
                )}
            />
        </Grid>
        
      </Grid>
    </SimpleForm>
  );
};
